import type { FilterGroup, SiteCategory } from '../types'
import { SITE_CATEGORY_LABELS, REUSE_NETWORK } from './mapConfig'
import { MARKER_CONFIG } from './markerConfig'

export const FILTER_GROUPS: FilterGroup[] = [
  {
    key: 'categories',
    label: 'Category',
    options: [
      ...Object.entries(SITE_CATEGORY_LABELS).map(([value, label]) => ({
        value,
        label,
        swatch: MARKER_CONFIG[value as SiteCategory]?.color,
      })),
      { value: 'TECHOWL', label: REUSE_NETWORK.name, swatch: '#6b6f7d' },
    ].sort((a, b) => a.label.localeCompare(b.label)),
  },
]
